import { gql } from '@eti/schema-types';

export const ORDER_QUERY = gql(/* GraphQL */ `
  query getOrderOnReceiptPage {
    links {
      baggageInformation
    }
    orderNew {
      addOnOrders {
        price {
          price {
            value
          }
        }
        creationDate
        extraProducts {
          productSpecificTexts {
            ... on ProductSegmentAvailabilityTexts {
              __typename
              productSegmentAvailabilityTexts {
                arrivalAirport
                departureAirport
                departureDateTime
                flightNumber
                available
                boundType
              }
            }
          }
          id
          name
          productSummaryAlternativeName
          code
          tripId
          price {
            price {
              value
            }
          }
          buySpecification {
            ... on BuySpecificationCartTraveler {
              __typename
              travelerPrices {
                travelerId
                price {
                  price {
                    value
                  }
                }
              }
            }
            ... on BuySpecificationCartTravelerBaggage {
              __typename
              travelerBaggageTripPrices {
                travelerId
                maxWeight
                weightUnit
                pieces
                price {
                  price {
                    value
                  }
                }
              }
            }
            ... on BuySpecificationCartTravelerChoice {
              __typename
              travelerChoicePrices {
                travelerId
                choice
                price {
                  price {
                    value
                  }
                }
              }
            }
            ... on BuySpecificationCartTravelerSeatMap {
              __typename
              travelerSeatMapPrices {
                travelerId
                boundIndex
                segmentIndex
                seat
                price {
                  price {
                    value
                  }
                }
              }
            }
          }
        }
        orderNumber
      }
      shouldAddInstallmentFeeInTotalAmount
      totalPriceIncludingAddOnOrders
      customerDetails {
        name
        street
        city
        zipCode
        email
        phone
        nationality {
          code
          name
        }
      }
      orderInformation {
        header
        text
      }
      transactionBreakdown {
        carrierName
        transactionAmount {
          price {
            currency {
              code
              name
              exponent
            }
            value
          }
        }
      }
      obfuscatedOrderReference
      oldOrderNumber
      orderNumber
      purchaseDate
      orderReferenceSerialized
      hasBeenChanged
      isRefunded
      isUpsellAllowed
      trips {
        fareRules {
          header
          content
        }
        includedCheckedBaggage {
          ...IncludedCheckedBaggage
        }
        bounds {
          boundId: id
          includedCheckedBaggage {
            ...IncludedCheckedBaggage
          }
          segments {
            ... on TripSegment {
              __typename
              arrivedAt
              brandedFareInformation {
                name
              }
              cabinClassName
              departuredAt
              duration
              destination {
                code
                name
                cityCode
                cityName
              }
              equipmentCode
              segmentId: id
              includedCheckedBaggage {
                ...IncludedCheckedBaggage
              }
              marketingCarrier {
                code
                name
              }
              numberOfTechnicalStops
              operatingCarrier {
                code
                name
              }
              operatingInformation
              origin {
                code
                name
                cityCode
                cityName
              }
              pnr
            }
            ... on EventSegment {
              __typename
              types
              duration
              segmentId: id
            }
          }
        }
        checkedBaggageSummary {
          tripSummaries {
            travelerId
            baggageDetails {
              pieces
              weight
              weightUnit
            }
            baggageStatus
          }
          boundSummaries {
            boundId
            summaries {
              travelerId
              baggageDetails {
                pieces
                weight
                weightUnit
              }
              baggageStatus
            }
            segmentSummaries {
              segmentId
              summaries {
                travelerId
                baggageDetails {
                  pieces
                  weight
                  weightUnit
                }
                baggageStatus
              }
            }
          }
        }
        extraProducts {
          productSpecificTexts {
            ... on ProductSegmentAvailabilityTexts {
              __typename
              productSegmentAvailabilityTexts {
                arrivalAirport
                departureAirport
                departureDateTime
                flightNumber
                available
                boundType
              }
            }
          }
          id
          name
          productSummaryAlternativeName
          code
          tripId
          price {
            price {
              value
            }
          }
          buySpecification {
            ... on BuySpecificationCartTraveler {
              __typename
              travelerPrices {
                travelerId
                price {
                  price {
                    value
                  }
                }
              }
            }
            ... on BuySpecificationCartTravelerBaggage {
              __typename
              travelerBaggageTripPrices {
                travelerId
                maxWeight
                weightUnit
                pieces
                price {
                  price {
                    value
                  }
                }
              }
            }
            ... on BuySpecificationCartTravelerChoice {
              __typename
              travelerChoicePrices {
                travelerId
                choice
                price {
                  price {
                    value
                  }
                }
              }
            }
            ... on BuySpecificationCartTravelerSeatMap {
              __typename
              travelerSeatMapPrices {
                travelerId
                boundIndex
                segmentIndex
                seat
                price {
                  price {
                    value
                  }
                }
              }
            }
          }
        }
        ancillaryBundles {
          id
          name
          selectedOption
          options {
            id
            name
            content {
              name
              included
            }
            price {
              price {
                value
              }
            }
          }
        }
        travelers {
          ageType
          firstName
          id
          lastName
          name
        }
        travelerPrices {
          price {
            price {
              value
            }
            vat {
              value
            }
            markup {
              value
            }
          }
          taxesAndFees {
            category
            taxes {
              code
              title
              amount {
                value
              }
            }
          }
          travelerId
        }
        type
        systems
        tripCharacteristics
      }
      flightInformation {
        loginEmail
        pnr
        url
      }
      totalPrice
      discountPrice {
        price {
          value
        }
      }
      chargeCurrencyPriceFormat {
        currencySymbol
        decimalSymbol
        currencyExponent
        groupingSeparator
        pattern
      }
      priceInChargeCurrency {
        price {
          currency {
            code
          }
          value
        }
      }
      instalmentsTotalFee
      paymentProducts {
        productSummaryAlternativeName
        price {
          price {
            value
          }
        }
        code
        name
        type
        cardSubType
        maskedCardNumber
      }
      postBookingLink
      travelDocLink
    }
  }
`);
